// 킴스온 이전 섹션 URL (2026-11-02 KST 추가)
export const kimsonImportPath = "/kimson-import";
